const crud = { c: false, r: false, u: false, d: false };

export const security = Object.freeze({
  security: { ...crud },
});
